export enum routes {
  ABOUT = '/about',
  INDEX_HTML = '/index.html',
  ROOT = '/',
  SETTINGS = '/settings',
  ACTIONS = '/actions',
  TRACING = '/tracing',
  ANALYTICS = '/analytics',
  PUSH_NOTIFICATION = '/push',
  SNAPSHOTS = '/snapshots',
}
